module.exports = __webpack_public_path__ + "static/media/Arrangement of return of minor.aaf05c73.png";